// eslint-disable-next-line import/no-named-as-default
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import { CookieKeys, Languages } from './constants/constants';

const namespaces = [
  'common',
  'auth',
  'about',
  'channels',
  'company',
  'notifications',
  'settings',
  'billing',
  'profile',
  'integrations',
];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    preload: [Languages.Ru, Languages.En],
    fallbackLng: Languages.Ru,
    detection: { lookupCookie: CookieKeys.Language },
    debug: false,
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    react: { useSuspense: true, nsMode: 'fallback' },
    backend: { loadPath: `/locales/{{lng}}/{{ns}}.json` },
    ns: namespaces,
    defaultNS: 'common', // Default namespace
    fallbackNS: 'common', // Fallback namespace
  });

// eslint-disable-next-line import/no-default-export
export default i18n;
